import { EventEmitter } from '@angular/core';

export abstract class NotificationBodyBase {
  public title?: string;
  public message?: string;
  public messageHTML?: string;
  public actionButtonLabel?: string;
  public actionButtonClick: EventEmitter<void>;

  public abstract setTitle(title: string): void;

  public abstract setMessage(message: string | null): void;

  public abstract setMessageHTML(message: string | null): void;
}
